import React from 'react';
import { fetchLoginWrapper } from '../../APIManager';
const AuthStateContext = /*#__PURE__*/React.createContext();
const AuthDispatchContext = /*#__PURE__*/React.createContext();
const initialState = {
  api_key: null,
  user_authenticated: false,
  platform_user_id: null,
  // value retrieved from login API call, ex: 1406
  auth_user_avatar: null,
  discourse_user_id: null,
  // value retrieved from user API call, ex: 4
  username: null,
  // the username of the user - value retrieved from user API call
  user_name: null,
  // the name of the user
  groups: [],
  // names discourse groups user is a member of
  can_send_dms: false,
  // if the user is allowed to send DMs
  dm_option_on: false,
  // if the user has "DM" option checked
  moderator: false,
  // if value from user API call is true, change it to true
  platform_user: {}
};

/** REDUCER **/
function AuthReducer(state, action) {
  switch (action.type) {
    case 'SET_API_KEY':
      return {
        ...state,
        api_key: action.payload
      };
    case 'SET_USER_AUTHENTICATED':
      return {
        ...state,
        user_authenticated: action.payload
      };
    case 'SET_PLATFORM_USER_ID':
      return {
        ...state,
        platform_user_id: action.payload
      };
    case 'SET_DISCOURSE_USER_ID':
      return {
        ...state,
        discourse_user_id: action.payload
      };
    case 'SET_USERNAME':
      return {
        ...state,
        username: action.payload
      };
    case 'SET_USER_NAME':
      return {
        ...state,
        user_name: action.payload
      };
    case 'SET_GROUPS':
      return {
        ...state,
        groups: action.payload
      };
    case 'SET_AUTH_USER_AVATAR':
      return {
        ...state,
        auth_user_avatar: action.payload
      };
    case 'SET_DM_ABILITY':
      return {
        ...state,
        can_send_dms: action.payload
      };
    case 'SET_DMS_ON':
      return {
        ...state,
        dm_option_on: action.payload
      };
    case 'SET_MODERATOR':
      return {
        ...state,
        moderator: action.payload
      };
    case 'SET_PLATFORM_USER':
      return {
        ...state,
        platform_user: action.payload
      };
    case 'GET_INITIAL':
      return initialState;
    default:
      {
        throw new Error('Unhandled action type caught');
      }
  }
}

/** PROVIDER **/
function AuthProvider({
  value,
  children
}) {
  const [state, dispatch] = React.useReducer(AuthReducer, initialState);
  return /*#__PURE__*/React.createElement(AuthStateContext.Provider, {
    value: state
  }, /*#__PURE__*/React.createElement(AuthDispatchContext.Provider, {
    value: dispatch
  }, children));
}

/** STATE/DISPATCH HOOKS **/
function useAuthState() {
  const context = React.useContext(AuthStateContext);
  if (context === undefined) {
    throw new Error('useAuthState must be used within a AuthProvider');
  }
  return context;
}
function useAuthDispatch() {
  const context = React.useContext(AuthDispatchContext);
  if (context === undefined) {
    throw new Error('useAuthDispatch must be used within a AuthProvider');
  }
  return context;
}

/** API **/
const authAPI = {
  doUserLogin: async function (url, loginEmail, loginPassword) {
    try {
      const formData = {
        email: loginEmail,
        password: loginPassword
      };
      const response = await fetchLoginWrapper(url, formData);
      return response;
    } catch (err) {
      console.log('Error while logging in');
      return {};
    }
  }
};

/** Util routines */
const authUtil = {
  userAuthed: state => {
    return state.user_authenticated && state.platform_user_id && state.discourse_user_id ? true : false;
  }
};
export { AuthProvider, useAuthState, useAuthDispatch, authAPI, authUtil };
//# sourceMappingURL=index.js.map